import * as React from 'react';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { CalendarPicker } from '@mui/x-date-pickers/CalendarPicker';

export default function TaskDatePicker({ date, setDate, editData }) {
  const handleChange = (newDate) => {
    setDate({ date: newDate });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CalendarPicker
        date={date.date}
        onChange={(newDate) => handleChange(newDate)}
        maxDate={new Date()}
        minDate={
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
        }
      />
    </LocalizationProvider>
  );
}
